/**
 * Returns the affiliate code stored in the `dba` cookie, or undefined if absent.
 * Cookie is written by AffiliateTracker in App.js when ?aff=CODE lands.
 */
export const getAffiliateCookieCode = () => {
  const match = document.cookie.match(/(?:^|;\s*)dba=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : undefined;
};
